module.exports = "<form #form=\"ngForm\">\r\n  <spk-card [class]=\"'col-md-4'\" meta=\"{{ getActionText() }} Country\" title=\"{{model.Name}}\" [divider]=\"true\">\r\n    <spk-text [name]=\"'Name'\" [maxlength]=\"200\" [(model)]=\"model.Name\"></spk-text>\r\n    <spk-checkbox [name]=\"'IsInternational'\" [(model)]=\"model.IsInternational\"></spk-checkbox>\r\n    <spk-checkbox [name]=\"'IsActive'\" [(model)]=\"model.IsActive\"></spk-checkbox>\r\n  </spk-card>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/countries/country/country.component.html
// module id = ./src/app/components/admin/countries/country/country.component.html
// module chunks = main